import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class CreateTour extends Component {
  // Custom styles for react-select to match Input border
  selectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#556ee6" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(85,110,230,.25)" : "none",
      "&:hover": {
        borderColor: "#556ee6",
      },
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#f1f1f1",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#556ee6"
        : state.isFocused
          ? "#e9ecef"
          : "white",
      color: state.isSelected ? "white" : "#495057",
      cursor: "pointer",
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Tours", link: "/tours" },
        { title: "Create Tour", link: "#" },
      ],
      categories: [],
      selectedCategory: "",
      selectedTourCategory: "",
      trendingCategories: [],
      selectedTrendingCategory: "",
      tourName: "",
      tourDescription: "",
      duration: "",
      destinations: [], // fetched destination list
      selectedDestinations: [], // selected destinations
      price: "",
      priceBasis: "Per Person Twin Sharing",
      inclusions: [],
      selectedInclusions: [],
      exclusions: [],
      selectedExclusions: [],
      dayWiseDescriptions: [{ day: 1, title: "", sightseeing_included: "", inclusion: "", activities: [{ text: "", image: null, imagePreview: null }] }],
      fromDate: null,
      toDate: null,
      tourImage: null,
      imagePreview: null,
      errors: {},
      isSubmitting: false,
    };
  }

  componentDidMount() {
    this.fetchCategories();
    this.fetchTrendingCategories();
    this.fetchInclusions();
    this.fetchExclusions();
    this.fetchDestinations();
  }

  // ✅ Updated destination fetch to use _id as value
  fetchDestinations = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/destinations`);
      const data = await response.json();
      if (response.ok) {
        const options = (Array.isArray(data) ? data : []).map((dest) => ({
          value: dest._id, // ✅ Send ObjectId to backend
          label: dest.destination_name,
        }));
        this.setState({ destinations: options });
      } else {
        console.error("Failed to fetch destinations:", data);
      }
    } catch (error) {
      console.error("Error fetching destinations:", error);
    }
  };

  fetchInclusions = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/tourinclusions`);
      const data = await response.json();
      if (response.ok) {
        const options = (Array.isArray(data) ? data : []).map((inc) => ({
          value: inc.tourinclusion_name,
          label: inc.tourinclusion_name,
        }));
        this.setState({ inclusions: options });
      } else {
        console.error("Failed to fetch inclusions:", data);
      }
    } catch (error) {
      console.error("Error fetching inclusions:", error);
    }
  };

  fetchExclusions = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/tourexclusions`);
      const data = await response.json();
      if (response.ok) {
        const options = (Array.isArray(data) ? data : []).map((exc) => ({
          value: exc.tourexclusion_name,
          label: exc.tourexclusion_name,
        }));
        this.setState({ exclusions: options });
      } else {
        console.error("Failed to fetch exclusions:", data);
      }
    } catch (error) {
      console.error("Error fetching exclusions:", error);
    }
  };

  fetchCategories = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/categories`);
      const data = await response.json();
      if (response.ok) {
        this.setState({ categories: data });
      } else {
        console.error("Failed to fetch categories:", data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  fetchTrendingCategories = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/trending-categories`);
      const data = await response.json();
      if (response.ok) {
        this.setState({ trendingCategories: data.data || data });
      } else {
        console.error("Failed to fetch trending categories:", data);
      }
    } catch (error) {
      console.error("Error fetching trending categories:", error);
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ 
      [name]: value,
      errors: { ...this.state.errors, [name]: null }
    });
  };

  handleInclusionsChange = (selectedOptions) => {
    this.setState({ selectedInclusions: selectedOptions || [] });
  };

  handleExclusionsChange = (selectedOptions) => {
    this.setState({ selectedExclusions: selectedOptions || [] });
  };

  handleDestinationsChange = (selectedOptions) => {
    this.setState({ 
      selectedDestinations: selectedOptions || [],
      errors: { ...this.state.errors, selectedDestinations: null }
    });
  };

  handleDayTitleChange = (dayIndex, value) => {
    const updatedDays = [...this.state.dayWiseDescriptions];
    updatedDays[dayIndex].title = value;
    this.setState({ dayWiseDescriptions: updatedDays });
  };

  handleSightseeingChange = (dayIndex, value) => {
    const updatedDays = [...this.state.dayWiseDescriptions];
    updatedDays[dayIndex].sightseeing_included = value;
    this.setState({ dayWiseDescriptions: updatedDays });
  };

  handleDayInclusionChange = (dayIndex, value) => {
    const updatedDays = [...this.state.dayWiseDescriptions];
    updatedDays[dayIndex].inclusion = value;
    this.setState({ dayWiseDescriptions: updatedDays });
  };

  handleActivityChange = (dayIndex, activityIndex, value) => {
    const updatedDays = [...this.state.dayWiseDescriptions];
    updatedDays[dayIndex].activities[activityIndex].text = value;
    this.setState({ dayWiseDescriptions: updatedDays });
  };

  handleActivityImageChange = (dayIndex, activityIndex, file) => {
    console.log('🔍 handleActivityImageChange called:', { dayIndex, activityIndex, file });
    const updatedDays = [...this.state.dayWiseDescriptions];
    if (file) {
      console.log('✅ File selected:', file.name, file.size, file.type);
      updatedDays[dayIndex].activities[activityIndex].image = file;
      const imagePreview = URL.createObjectURL(file);
      updatedDays[dayIndex].activities[activityIndex].imagePreview = imagePreview;
      console.log('✅ Image preview created:', imagePreview);
    } else {
      console.log('❌ No file selected, clearing image');
      updatedDays[dayIndex].activities[activityIndex].image = null;
      updatedDays[dayIndex].activities[activityIndex].imagePreview = null;
    }
    this.setState({ dayWiseDescriptions: updatedDays }, () => {
      console.log('🔄 State updated - Activity:', this.state.dayWiseDescriptions[dayIndex].activities[activityIndex]);
      console.log('🔄 All activities with images:', 
        this.state.dayWiseDescriptions.map((day, dIdx) => 
          day.activities.map((act, aIdx) => ({
            day: dIdx,
            activity: aIdx,
            hasImage: !!act.image,
            fileName: act.image?.name
          }))
        ).flat()
      );
    });
  };

  addActivity = (dayIndex) => {
    const updatedDays = [...this.state.dayWiseDescriptions];
    updatedDays[dayIndex].activities.push({ text: "", image: null, imagePreview: null });
    this.setState({ dayWiseDescriptions: updatedDays });
  };

  removeActivity = (dayIndex, activityIndex) => {
    const updatedDays = [...this.state.dayWiseDescriptions];
    if (updatedDays[dayIndex].activities.length > 1) {
      updatedDays[dayIndex].activities.splice(activityIndex, 1);
      this.setState({ dayWiseDescriptions: updatedDays });
    }
  };

  addDay = () => {
    const newDay = {
      day: this.state.dayWiseDescriptions.length + 1,
      title: "",
      sightseeing_included: "",
      inclusion: "",
      activities: [{ text: "", image: null, imagePreview: null }],
    };
    this.setState({
      dayWiseDescriptions: [...this.state.dayWiseDescriptions, newDay],
    });
  };

  removeDay = (index) => {
    if (this.state.dayWiseDescriptions.length > 1) {
      const updatedDays = this.state.dayWiseDescriptions.filter((_, i) => i !== index);
      // Renumber days
      const renumberedDays = updatedDays.map((day, i) => ({ ...day, day: i + 1 }));
      this.setState({ dayWiseDescriptions: renumberedDays });
    }
  };

  handleCategoryChange = (e) => {
    this.setState({ 
      selectedCategory: e.target.value,
      errors: { ...this.state.errors, selectedCategory: null }
    });
  };

  handleTourCategoryChange = (e) => {
    this.setState({ 
      selectedTourCategory: e.target.value,
      errors: { ...this.state.errors, selectedTourCategory: null }
    });
  };

  handleTrendingCategoryChange = (e) => {
    this.setState({ selectedTrendingCategory: e.target.value });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log("Image file selected:", file);
    if (file) {
      console.log("Setting tour image:", file.name, file.size);
      this.setState({
        tourImage: file,
        imagePreview: URL.createObjectURL(file),
        errors: { ...this.state.errors, tourImage: null }
      });
    } else {
      console.log("No file selected");
    }
  };

  validateForm = () => {
    const errors = {};
    
    if (!this.state.selectedCategory) {
      errors.selectedCategory = "Please select a State/Country Name";
    }
    
    if (!this.state.tourName.trim()) {
      errors.tourName = "Please enter a Tour Name";
    }
    
    if (!this.state.selectedDestinations || this.state.selectedDestinations.length === 0) {
      errors.selectedDestinations = "Please select at least one destination";
    }
    
    if (!this.state.tourDescription.trim()) {
      errors.tourDescription = "Please enter a tour description";
    }
    
    // Make tour image optional for testing
    // if (!this.state.tourImage) {
    //   errors.tourImage = "Please select a Tour Image";
    // }
    
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log("🚀 Form submission started");
    console.log("🖼️ Tour image state:", this.state.tourImage);
    console.log("🖼️ Tour image file:", this.state.tourImage ? this.state.tourImage.name : "No file");
    
    if (!this.validateForm()) {
      console.log("❌ Form validation failed");
      return;
    }
    
    this.setState({ isSubmitting: true, errors: {} });

    try {
      const formData = new FormData();
      formData.append("category_name", this.state.selectedCategory);
      if (this.state.selectedTourCategory) {
        formData.append("tour_category", this.state.selectedTourCategory);
      }
      if (this.state.selectedTrendingCategory) {
        formData.append("trendingCategoryId", this.state.selectedTrendingCategory);
      }
      formData.append("tour_name", this.state.tourName);
      if (this.state.duration) {
        formData.append("duration", this.state.duration);
      }

      // ✅ Append destination IDs as array of ObjectIds
      this.state.selectedDestinations.forEach((dest) => {
        formData.append("destinations[]", dest.value);
      });

      if (this.state.price) {
        formData.append("price", this.state.price);
      }
      if (this.state.priceBasis) {
        formData.append("price_basis", this.state.priceBasis);
      }

      this.state.selectedInclusions.forEach((inc) => {
        formData.append("includes[]", inc.value);
      });

      this.state.selectedExclusions.forEach((exc) => {
        formData.append("excludes[]", exc.value);
      });

      // 🔍 Debug: Check activity images before processing
      console.log("🔍 Checking activity images before processing:");
      this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
        day.activities.forEach((activity, activityIndex) => {
          console.log(`Day ${dayIndex}, Activity ${activityIndex}:`, {
            hasImage: !!activity.image,
            fileName: activity.image?.name,
            fileSize: activity.image?.size,
            text: activity.text
          });
        });
      });

      // Add day-wise descriptions with activity images (only if there's content)
      const hasValidDayWiseContent = this.state.dayWiseDescriptions.some(day => 
        day.title.trim() || day.activities.some(activity => activity.text.trim())
      );
      
      console.log("🔍 Has valid day-wise content:", hasValidDayWiseContent);
      
      if (hasValidDayWiseContent) {
        // Create dayWiseData structure and track activity images separately
        const dayWiseData = this.state.dayWiseDescriptions.map((day, dayIndex) => ({
          day: day.day,
          title: day.title,
          sightseeing_included: day.sightseeing_included || "",
          inclusion: day.inclusion || "",
          activities: day.activities
            .map((activity, activityIndex) => ({
              description: (activity.text || "").trim(),
              activity_image: activity.image ? `activity_${dayIndex}_${activityIndex}` : null
            }))
            .filter(act => act.description || act.activity_image)
        }));
        
        console.log("🔍 Day-wise data structure:", JSON.stringify(dayWiseData, null, 2));
        formData.append("dayWiseDescriptions", JSON.stringify(dayWiseData));
        
        // 🔍 Debug: Count activity images to be added
        let activityImageCount = 0;
        
        // Add activity images as separate binary fields (like tour_image)
        this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
          day.activities.forEach((activity, activityIndex) => {
            if (activity.image) {
              const fieldName = `activity_${dayIndex}_${activityIndex}`;
              console.log(`📎 Adding activity image: ${fieldName}`, {
                fileName: activity.image.name,
                fileSize: activity.image.size,
                fileType: activity.image.type
              });
              formData.append(fieldName, activity.image);
              activityImageCount++;
            }
          });
        });
        
        console.log(`📊 Total activity images added to FormData: ${activityImageCount}`);
      }

      formData.append(
        "from_date",
        this.state.fromDate ? this.state.fromDate.toISOString() : ""
      );
      formData.append(
        "to_date",
        this.state.toDate ? this.state.toDate.toISOString() : ""
      );
      formData.append("description", this.state.tourDescription);
      
      console.log("🔍 About to append tour_image:", this.state.tourImage);
      if (this.state.tourImage) {
        formData.append("tour_image", this.state.tourImage);
        console.log("✅ tour_image appended successfully");
      } else {
        console.log("❌ No tour_image to append");
      }

      console.log("📤 Sending tour data:", {
        category: this.state.selectedCategory,
        name: this.state.tourName,
        duration: this.state.duration,
        destinations: this.state.selectedDestinations.map((d) => d.value),
        price: this.state.price,
        inclusions: this.state.selectedInclusions.map((i) => i.value),
      });

      // 🔍 Debug: Log FormData contents
      console.log("📋 FormData contents:");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`${key}: [File] ${value.name} (${value.size} bytes, ${value.type})`);
        } else {
          console.log(`${key}: ${value}`);
        }
      }

      // 🔍 UNCOMMENTED API CALL FOR TESTING
      const response = await fetch(`${config.API_BASE_URL}/tours`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        console.log("✅ Tour created successfully:", data);
        alert("Tour created successfully!");
        this.props.router.navigate("/tours");
      } else {
        console.error("❌ Failed to create tour:", data);
        this.setState({ 
          errors: { submit: data.message || "Failed to create tour" },
          isSubmitting: false 
        });
      }
    } catch (error) {
      console.error("💥 Error:", error);
      this.setState({ 
        errors: { submit: "Error creating tour" },
        isSubmitting: false 
      });
    }
  };

  handleCancel = () => {
    this.props.router.navigate("/tours");
  };

  render() {
    const {
      fromDate,
      toDate,
      inclusions,
      selectedInclusions,
      selectedDestinations,
      destinations,
    } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Create Tour"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Form onSubmit={(e) => {
                      console.log("🔍 Form onSubmit triggered!");
                      this.handleSubmit(e);
                    }}>
                      <Row>
                        {/* Category */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">State / Country Name <span className="text-danger">*</span></Label>
                            <Input
                              type="select"
                              value={this.state.selectedCategory}
                              onChange={this.handleCategoryChange}
                              required
                              className={this.state.errors.selectedCategory ? "is-invalid" : ""}
                            >
                              <option value="">Select State / Country Name</option>
                              {this.state.categories.map((cat) => (
                                <option
                                  key={cat._id || cat.id}
                                  value={cat.category_name}
                                >
                                  {cat.category_name}
                                </option>
                              ))}
                            </Input>
                            {this.state.errors.selectedCategory && (
                              <div className="invalid-feedback d-block">
                                {this.state.errors.selectedCategory}
                              </div>
                            )}
                          </div>
                        </Col>

                        {/* Tour Category */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Tour Category</Label>
                            <Input
                              type="select"
                              value={this.state.selectedTourCategory}
                              onChange={this.handleTourCategoryChange}
                              className={this.state.errors.selectedTourCategory ? "is-invalid" : ""}
                            >
                              <option value="">Select Tour Category</option>
                              {this.state.categories.map((cat) => (
                                <option
                                  key={`tour-cat-${cat._id || cat.id}`}
                                  value={cat.category_name}
                                >
                                  {cat.category_name}
                                </option>
                              ))}
                            </Input>
                          </div>
                        </Col>

                        {/* Trending Category */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Trending Category
                            </Label>
                            <Input
                              type="select"
                              value={this.state.selectedTrendingCategory}
                              onChange={this.handleTrendingCategoryChange}
                            >
                              <option value="">Select Trending Category</option>
                              {this.state.trendingCategories.map((trendingCat) => (
                                <option
                                  key={trendingCat._id || trendingCat.id}
                                  value={trendingCat._id || trendingCat.id}
                                >
                                  {trendingCat.name}
                                </option>
                              ))}
                            </Input>
                          </div>
                        </Col>

                        {/* Tour Name */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Tour Name <span className="text-danger">*</span></Label>
                            <Input
                              type="text"
                              name="tourName"
                              placeholder="Enter tour name"
                              value={this.state.tourName}
                              onChange={this.handleInputChange}
                              required
                              className={this.state.errors.tourName ? "is-invalid" : ""}
                            />
                            {this.state.errors.tourName && (
                              <div className="invalid-feedback d-block">
                                {this.state.errors.tourName}
                              </div>
                            )}
                          </div>
                        </Col>

                        {/* Duration */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Duration</Label>
                            <Input
                              type="text"
                              name="duration"
                              placeholder="e.g., 3 Days, 2 Nights"
                              value={this.state.duration}
                              onChange={this.handleInputChange}
                            />
                          </div>
                        </Col>

                        {/* ✅ Destination select (multi) */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Destinations <span className="text-danger">*</span></Label>
                            <Select
                              isMulti
                              name="destinations"
                              options={destinations}
                              value={selectedDestinations}
                              onChange={this.handleDestinationsChange}
                              placeholder="Select destinations..."
                              isClearable
                              isSearchable
                              classNamePrefix="react-select"
                              styles={this.selectStyles}
                              className={this.state.errors.selectedDestinations ? "is-invalid" : ""}
                            />
                            {this.state.errors.selectedDestinations && (
                              <div className="invalid-feedback d-block">
                                {this.state.errors.selectedDestinations}
                              </div>
                            )}
                          </div>
                        </Col>

                        {/* Price */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Price (INR)</Label>
                            <Input
                              type="number"
                              name="price"
                              placeholder="Enter price"
                              value={this.state.price}
                              onChange={this.handleInputChange}
                            />
                          </div>
                        </Col>

                        {/* Price Basis */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Price Basis</Label>
                            <Input
                              type="select"
                              name="priceBasis"
                              value={this.state.priceBasis}
                              onChange={this.handleInputChange}
                            >
                              <option value="Per Person Twin Sharing">
                                Per Person Twin Sharing
                              </option>
                              <option value="Per Person Single Occupancy">
                                Per Person Single Occupancy
                              </option>
                              <option value="Per Couple">Per Couple</option>
                              <option value="Per Family">Per Family</option>
                            </Input>
                          </div>
                        </Col>

                        {/* Includes */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Includes</Label>
                            <Select
                              isMulti
                              name="includes"
                              options={inclusions}
                              value={selectedInclusions}
                              onChange={this.handleInclusionsChange}
                              placeholder="Select inclusions..."
                              isClearable
                              isSearchable
                              classNamePrefix="react-select"
                              styles={this.selectStyles}
                            />
                          </div>
                        </Col>

                        {/* Excludes */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Excludes</Label>
                            <Select
                              isMulti
                              name="excludes"
                              options={this.state.exclusions}
                              value={this.state.selectedExclusions}
                              onChange={this.handleExclusionsChange}
                              placeholder="Select exclusions..."
                              isClearable
                              isSearchable
                              classNamePrefix="react-select"
                              styles={this.selectStyles}
                            />
                          </div>
                        </Col>

                        {/* Description */}
                        <Col md={12}>
                          <div className="mb-3">
                            <Label className="form-label">Description <span className="text-danger">*</span></Label>
                            <Input
                              type="textarea"
                              name="tourDescription"
                              placeholder="Enter tour description"
                              value={this.state.tourDescription}
                              onChange={this.handleInputChange}
                              rows="3"
                              required
                              className={this.state.errors.tourDescription ? "is-invalid" : ""}
                            />
                            {this.state.errors.tourDescription && (
                              <div className="invalid-feedback d-block">
                                {this.state.errors.tourDescription}
                              </div>
                            )}
                          </div>
                        </Col>

                        {/* Day-wise Descriptions */}
                        <Col md={12}>
                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <Label className="form-label mb-0">
                                <strong>Day-wise Itinerary</strong>
                              </Label>
                              <Button
                                type="button"
                                color="success"
                                size="sm"
                                onClick={this.addDay}
                              >
                                <i className="ri-add-line"></i> Add Day
                              </Button>
                            </div>
                            {this.state.dayWiseDescriptions.map((day, dayIndex) => (
                              <Card key={dayIndex} className="mb-3">
                                <CardBody>
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Day {day.day}</h5>
                                    {this.state.dayWiseDescriptions.length > 1 && (
                                      <Button
                                        type="button"
                                        color="danger"
                                        size="sm"
                                        onClick={() => this.removeDay(dayIndex)}
                                      >
                                        <i className="ri-delete-bin-line"></i> Remove Day
                                      </Button>
                                    )}
                                  </div>

                                  {/* Day Title */}
                                  <div className="mb-3">
                                    <Label className="form-label">Day Title</Label>
                                    <Input
                                      type="text"
                                      placeholder="e.g., ARRIVAL AT COCHIN AIRPORT/RAILWAYSTATION"
                                      value={day.title}
                                      onChange={(e) => this.handleDayTitleChange(dayIndex, e.target.value)}
                                    />
                                  </div>

                                  {/* Optional Day Fields */}
                                  <Row className="mb-3">
                                    <Col md={6}>
                                      <Label className="form-label">Sight Seeing Included (Optional)</Label>
                                      <Input
                                        type="text"
                                        placeholder="e.g. Full day sightseeing of Port Blair"
                                        value={day.sightseeing_included || ""}
                                        onChange={(e) => this.handleSightseeingChange(dayIndex, e.target.value)}
                                      />
                                    </Col>
                                    <Col md={6}>
                                      <Label className="form-label">Inclusion (Optional)</Label>
                                      <Input
                                        type="select"
                                        value={day.inclusion || ""}
                                        onChange={(e) => this.handleDayInclusionChange(dayIndex, e.target.value)}
                                      >
                                        <option value="">Select Inclusion (Optional)</option>
                                        {inclusions && inclusions.map((inc, i) => (
                                          <option key={i} value={inc.value || inc.label || inc}>
                                            {inc.label || inc.value || inc}
                                          </option>
                                        ))}
                                      </Input>
                                    </Col>
                                  </Row>

                                  {/* Activities */}
                                  <div className="mb-2">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <Label className="form-label mb-0">Activities</Label>
                                      <Button
                                        type="button"
                                        color="info"
                                        size="sm"
                                        onClick={() => this.addActivity(dayIndex)}
                                      >
                                        <i className="ri-add-line"></i> Add Activity
                                      </Button>
                                    </div>
                                    {day.activities.map((activity, activityIndex) => (
                                      <div key={activityIndex} className="mb-3 border p-3 rounded">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <Label className="form-label mb-0">Activity {activityIndex + 1}</Label>
                                          {day.activities.length > 1 && (
                                            <Button
                                              type="button"
                                              color="danger"
                                              size="sm"
                                              onClick={() => this.removeActivity(dayIndex, activityIndex)}
                                            >
                                              <i className="ri-close-line"></i> Remove
                                            </Button>
                                          )}
                                        </div>
                                        
                                        <Row>
                                          <Col md={8}>
                                            <Input
                                              type="text"
                                              placeholder={`Activity ${activityIndex + 1} description`}
                                              value={activity.text}
                                              onChange={(e) =>
                                                this.handleActivityChange(dayIndex, activityIndex, e.target.value)
                                              }
                                            />
                                          </Col>
                                          <Col md={4}>
                                            <Input
                                              type="file"
                                              accept="image/*"
                                              onChange={(e) => {
                                                console.log(`🔍 File input change for Day ${dayIndex}, Activity ${activityIndex}:`, e.target.files[0]);
                                                this.handleActivityImageChange(dayIndex, activityIndex, e.target.files[0]);
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                        
                                        {activity.imagePreview && (
                                          <Row className="mt-2">
                                            <Col md={6}>
                                              <p className="text-muted mb-1">Image preview:</p>
                                              <img
                                                src={activity.imagePreview}
                                                alt={`Activity ${activityIndex + 1} preview`}
                                                className="img-fluid"
                                                style={{ maxHeight: "150px" }}
                                                onLoad={() => console.log('Activity image preview loaded successfully')}
                                                onError={(e) => console.error('Activity image preview failed to load:', e)}
                                              />
                                            </Col>
                                          </Row>
                                        )}
                                        {console.log('Activity render check:', { 
                                          activityIndex, 
                                          hasImagePreview: !!activity.imagePreview,
                                          imagePreview: activity.imagePreview 
                                        })}
                                      </div>
                                    ))}
                                  </div>
                                </CardBody>
                              </Card>
                            ))}
                          </div>
                        </Col>

                        {/* Debug Button - Remove this after testing */}
                        {/* <Col md={12}>
                          <div className="mb-3">
                            <Button
                              type="button"
                              color="info"
                              size="sm"
                              onClick={() => {
                                console.log("🔍 DEBUG: Current activity images state:");
                                this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
                                  console.log(`Day ${dayIndex + 1} (${day.title}):`);
                                  day.activities.forEach((activity, activityIndex) => {
                                    console.log(`  Activity ${activityIndex + 1}:`, {
                                      text: activity.text,
                                      hasImage: !!activity.image,
                                      fileName: activity.image?.name,
                                      fileSize: activity.image?.size,
                                      hasPreview: !!activity.imagePreview
                                    });
                                  });
                                });
                              }}
                            >
                              🔍 Debug Activity Images State
                            </Button>
                          </div>
                        </Col> */}

                        {/* Image Upload */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Tour Image<span className="text-danger">*</span></Label>
                            <Input
                              type="file"
                              onChange={this.handleImageChange}
                              accept="image/*"
                              className={this.state.errors.tourImage ? "is-invalid" : ""}
                            />
                            {this.state.errors.tourImage && (
                              <div className="invalid-feedback d-block">
                                {this.state.errors.tourImage}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>

                      {/* Image Preview */}
                      {this.state.imagePreview && (
                        <Row className="mt-3">
                          <Col md={6}>
                            <img
                              src={this.state.imagePreview}
                              alt="Tour Preview"
                              className="img-fluid"
                              style={{ maxHeight: "200px" }}
                            />
                          </Col>
                        </Row>
                      )}

                      {/* Error Messages */}
                      {this.state.errors.submit && (
                        <Row className="mt-3">
                          <Col md={12}>
                            <div className="alert alert-danger">
                              {this.state.errors.submit}
                            </div>
                          </Col>
                        </Row>
                      )}

                      {/* Buttons */}
                      <Row className="mt-4">
                        <Col className="d-flex justify-content-end">
                          <Button 
                            type="submit" 
                            color="primary" 
                            className="me-2"
                            disabled={this.state.isSubmitting}
                            onClick={(e) => {
                              console.log("🔍 Submit button clicked!");
                              // Don't prevent default here, let the form handle it
                            }}
                          >
                            {this.state.isSubmitting ? "Creating..." : "Create Tour"}
                          </Button>
                          <Button
                            type="button"
                            color="secondary"
                            onClick={this.handleCancel}
                            disabled={this.state.isSubmitting}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(CreateTour);
